import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/settings/ui/SettingsLayout';

export const Route = createFileRoute('/_authenticated/settings')({ component: SettingsLayout });
